import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import {
  useHotspotItem,
  HOTSPOT_FILTERS
} from '../../../context/HotspotsContext';

import PropertyTypeFilterDropdown from '../../PropertyTypeFilterDropdown';

import DropdownButton from '../../DropdownButton';
import PropertyTypeFilterTooltip from '../../PropertyTypeFilterTooltip';

import FiltersExposedTitle from './FiltersExposedTitle';
import FiltersExposedButton from './FiltersExposedButton';
import FiltersExposedInfoBox from './FiltersExposedInfoBox';

const PropertyTypeFilter = ({
  selectedPropertyTypes,
  isFilterOpen,
  onToggleFilter,
  onFiltersUpdate,
  totalResults,
  filters,
  className
}) => {
  const { setHotspotVisited, renderHotspotLed } = useHotspotItem(
    HOTSPOT_FILTERS.propertyType
  );

  const renderPropertyTypesButtonContent = () =>
    selectedPropertyTypes.length !== 0
      ? selectedPropertyTypes
          .map(propertyType =>
            trans(`search.applied-filters-modal.propertyType.${propertyType}`)
          )
          .join(', ')
      : trans('filters.label.property.type');

  const handleClose = () => {
    setHotspotVisited();
    onToggleFilter('property-type');
  };

  return (
    <DropdownButton
      isOpen={isFilterOpen}
      onToggle={() => onToggleFilter('property-type')}
      onClose={handleClose}
      className={className}
      dataTest="property-type-exposed-filter-button"
      renderButtonContent={() => (
        <>
          {renderHotspotLed()}
          {renderPropertyTypesButtonContent()}
        </>
      )}
      isSelected={selectedPropertyTypes.length !== 0}
      renderDropdownContent={handleDropdownClose => (
        <>
          <div className={'filters-exposed__content'}>
            <FiltersExposedTitle
              title={trans('filters.label.property.type')}
              subtitle={trans(
                'exposed-filters.dropdown.property.type.description'
              )}
              renderSubtitleTooltip={() => <PropertyTypeFilterTooltip />}
            />

            <FiltersExposedInfoBox filterName={HOTSPOT_FILTERS.propertyType} />
            <PropertyTypeFilterDropdown
              filters={filters}
              onFiltersUpdate={onFiltersUpdate}
              onButtonClick={handleDropdownClose}
              totalResults={totalResults}
            />
          </div>
          <FiltersExposedButton
            onClick={handleDropdownClose}
            text={trans('search.filters.view_close_filters', {
              nResults: `${totalResults}`
            })}
            dataTest="property-type-exposed-filter-apply"
            eventLabel="apply-property-type"
          />
        </>
      )}
    />
  );
};

PropertyTypeFilter.propTypes = {
  selectedPropertyTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isFilterOpen: PropTypes.bool.isRequired,
  onToggleFilter: PropTypes.func.isRequired,
  onFiltersUpdate: PropTypes.func.isRequired,
  totalResults: PropTypes.number.isRequired,
  filters: PropTypes.shape({}).isRequired,
  className: PropTypes.string
};

PropertyTypeFilter.defaultProps = {
  className: ''
};

export default PropertyTypeFilter;
